import { render, staticRenderFns } from "./addresses.vue?vue&type=template&id=4ceeaa08&"
import script from "./addresses.vue?vue&type=script&lang=js&"
export * from "./addresses.vue?vue&type=script&lang=js&"
import style0 from "./addresses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports